<template>
  <b-card title="Brime Beta APIv2 Inbound">
    <b-card-text>We will soon release our Beta APIv2. Stay tuned.</b-card-text>
  </b-card>
</template>

<script>
import { BCard, BCardText } from 'bootstrap-vue'

export default {
  components: {
    BCard,
    BCardText,
  },
}
</script>

<style>

</style>
